<template>
  <div>
    <modal-title>{{ $t('terms.skatmasters.title_rules') }}</modal-title>
    <modal-content>
      <t-text class="terms-text" v-html="md($t('terms.skatmasters.content_rules'))" />
    </modal-content>
    <modal-title>{{ $t('terms.skatmasters.title_conditions') }}</modal-title>
    <modal-content>
      <t-text class="terms-text" v-html="md($t('terms.skatmasters.content_conditions'))" />
      <t-text class="terms-text" v-html="md($t('terms.skatmasters.disclaimer_legal'))" />
    </modal-content>
  </div>
</template>

<script setup lang="ts">
import { marked } from 'marked'
function md(s: string) {
  return marked(s)
}
</script>

<style lang="less" scoped>
.terms-text {
  text-align: justify;
  &::v-deep {
    ul {
      padding-left: 1em;
    }
  }
}
</style>
